module.exports = __webpack_public_path__ + "img/gb9115_17_b.prt.89db387f.jpg";